//animations
import { motion } from 'framer-motion'
import styled from 'styled-components'
import { AnimPage } from '../Animation'

export default function ContactUS() {

    return (
      <FormPage variants={AnimPage} exit="exit" initial="hidden" animate="show">
      <Form>
      <form onSubmit={e => {e.preventDefault();}}>
        <h2>Contact</h2>
        <input
          id="first-name"
          className="form-field"
          type="text"
          placeholder="First Name"
          name="firstName"
        />
        <input
          id="last-name"
          className="form-field"
          type="text"
          placeholder="Last Name"
          name="lastName"
        />
        
        <input
          id="email"
          className="form-field"
          type="text"
          placeholder="Email"
          name="email"
        />
       
        <button  type="submit" >
         Register
        </button>
      </form>
    </Form>
        </FormPage>
    )
}

const FormPage = styled(motion.div)`
padding: 5rem 1rem;

`

const Form = styled.div`
@media(max-width: 1300px){
  width: 90%;
  h2{
    font-size: 3rem;
  }
  button{
    width: 100%;
    background-color: #23D997;
  }
}
width: 100%;
max-width: 500px;
margin: 0 auto;
padding: 2rem;
border: 3px solid #cccccc;
h2{
  color: #cccccc;
  margin-bottom: 3rem;
}
input{
    display: block;
    width: 100%;
    font-size: 1.2rem;
    line-height: 1.4;
    padding: 3px;
    margin-bottom: 3rem;
    outline: none;
    border: 0;
}
`
